// import axios from 'axios'
// import { route } from 'ziggy-js'

// export const loadZiggyRoutes = async () => {
//     try {
//         const response = await axios.get('/routes/ziggy')
//         console.log('called ziggy routes fetch')
//         return response.data
//     } catch (error) {
//         console.error('Error loading Ziggy routes:', error)
//         // catchError(error)
//         return null
//     }
// }

// export default async function (name, params = {}, absolute = true) {
//     const ziggyRoutes = await loadZiggyRoutes()
//     return route(name, params, absolute, ziggyRoutes)
// }

import axios from 'axios'
import { route } from 'ziggy-js'

// in mem cache
let cachedRoutes = null

const CACHE_EXPIRATION = 60 * 60 * 1000

export const loadZiggyRoutes = async (forceRefresh = false) => {
    if (!forceRefresh && cachedRoutes) {
        return cachedRoutes
    }

    const cachedData = localStorage.getItem('ziggy_routes')
    if (!forceRefresh && cachedData) {
        try {
            const { data, timestamp } = JSON.parse(cachedData)
            if (Date.now() - timestamp < CACHE_EXPIRATION) {
                cachedRoutes = data
                return data
            }
        } catch (error) {
            console.error('Error loading cached routes:', error)
        }
    }

    try {
        const response = await axios.get('/routes/ziggy')
        cachedRoutes = response.data

        localStorage.setItem(
            'ziggy_routes',
            JSON.stringify({
                data: response.data,
                timestamp: Date.now(),
            })
        )

        return response.data
    } catch (error) {
        console.error('Error loading ziggy routes:', error)
        return null
    }
}

export const refreshZiggyRoutes = () => {
    return loadZiggyRoutes(true)
}

export default async function ziggyRoute(name, params = {}, absolute = true) {
    const ziggyRoutes = await loadZiggyRoutes()
    return route(name, params, absolute, ziggyRoutes)
}
